import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import InviteUserForm, { InviteUserFormHandle } from "../forms/InviteUserForm";
import PrimaryButton from "../PrimaryButton";
import { User } from "../../types/user.types";
import { useRef, useState } from "react";
import PenIcon from "../icons/PenIcon";
import i18n from "../../i18n";
import TrashIcon from "../icons/TrashIcon";
import { useMutation } from "react-query";
import { sendInvitations } from "../../mutations/center.mutations";
import AddUserIcon from "../icons/AddUserIcon";
import { useCentersStore } from "../../stores/centers.store";
import { fPhoneNumber } from "../../lib/format";

type InviteUserModalProps = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: (users: Partial<User>[]) => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function InviteUserModal({ isOpen, onOpen: _, onClose }: InviteUserModalProps) {
  const [users, setUsers] = useState<Partial<User>[]>([]);
  const { center } = useCentersStore();
  const [editedUser, setEditedUser] = useState<Partial<User> | null>(null);
  const { mutate: mutateSendInvitations } = useMutation(sendInvitations)
  const formRef = useRef<InviteUserFormHandle>(null)

  const handleAddUser = (user: Partial<User>) => {
    if (!editedUser) {
      setUsers([...users, user]);
    } else {
      editedUser.firstName = user.firstName;
      editedUser.lastName = user.lastName;
      editedUser.email = user.email;
      editedUser.phoneNumber = user.phoneNumber;
      editedUser.role = user.role;
      editedUser.access = user.access;
      setEditedUser(null)
    }
  };
  const handleRemoveUser = (idx: number) => {
    setUsers(users.filter((_, index) => index !== idx))
  }
  const handleEditUser = (user: Partial<User>) => {
    setEditedUser(user)
  }
  const handleSendInvitation = async () => {
    if (center && formRef.current) {
      if (formRef.current.isDirty() === false) {
        mutateSendInvitations({ center, users }, {
          onSuccess: () => {
            onClose(users)
          }
        })
        return;
      }
      else if (await formRef.current.isValid()) {
        const allUsers = [...users, formRef.current.values()]
        mutateSendInvitations({ center, users: allUsers }, {
          onSuccess: () => {
            onClose(allUsers)
          }
        })
      }
    }
  }
  return (
    <Modal isOpen={isOpen} onClose={() => onClose(users)} isCentered closeOnOverlayClick={false}>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
      <ModalContent maxW={"none"} w="80vw">
        <ModalHeader>
          <AddUserIcon w="48px" h="48px" mr="8px"></AddUserIcon>
          Invitez des personnes à rejoindre le centre
        </ModalHeader>
        <ModalCloseButton onClick={() => onClose(users)} />
        <ModalBody>
          <Box w='100%'>
            {users.map((user, index) => {
              return <Flex key={user.email} w="100%">
                <Box w='14rem' flexGrow={0} textAlign="left">{user.firstName}&nbsp;{user.lastName}</Box>
                <Box w='auto' flexGrow={1} textAlign="left">{user.email}</Box>
                <Box w='10rem' flexGrow={0} textAlign="left">{fPhoneNumber(user.phoneNumber ?? "")}</Box>
                <Box w='8rem' flexGrow={0} textAlign="left" textTransform={"capitalize"}>{user.access && i18n.t(user.access)}</Box>
                <Box w='10rem' flexGrow={0} textAlign="left" textTransform={"capitalize"}>{user.role && i18n.t(user.role)}</Box>
                <Box w='3rem'  flexGrow={0}>
                  <TrashIcon onClick={() => handleRemoveUser(index)} mr={2}></TrashIcon>
                  <PenIcon onClick={() => handleEditUser(user)}></PenIcon>
                </Box>
              </Flex>;
            })}
          </Box>

          <Box borderTop="solid 1px #E2E8F0" mt={3}>
            <InviteUserForm ref={formRef} onSubmit={handleAddUser} defaultValue={ editedUser ? editedUser: undefined }></InviteUserForm>
          </Box>
        </ModalBody>
        <ModalFooter borderTop="solid 1px #E2E8F0">
          <PrimaryButton w={"fit-content"} onClick={handleSendInvitation}>
            Envoyer les invitations
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default InviteUserModal;
